module.exports = __webpack_public_path__ + "static/media/md-body.2bd3674a.svg";